import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import jwt_decode from 'jwt-decode';
import {checkTokenDates} from '../shared/tokenFunctions';

/**
 * A component that displays its contents if token is valid
 *
 */
class AuthenticatedContainer extends Component {

    isTokenValid(token) {
        if (token) {
            const decodedToken = jwt_decode(token);
            const exp = decodedToken.exp;
            if (exp) {
                let tokenStatus = checkTokenDates(exp);
                return !tokenStatus.expired;
            }
        }
        return false;
    }

    render() {
        const {
            children,
            token
        } = this.props;

        const tokenIsValid = this.isTokenValid(token);
        if (tokenIsValid) {
            return (
                <Fragment>
                    {children}
                </Fragment>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => {
    let form = state.form['tokenForm'];
    if (form && form.values) {
        const tokenValue = (form.values['token']) ? form.values['token'] : null;
        return {
            token: tokenValue,
        }
    }
    return {token: null}
};

AuthenticatedContainer.propTypes = {
    addField: PropTypes.bool,
    expired: PropTypes.bool,
    token: PropTypes.any
};

AuthenticatedContainer.defaultProps = {
    addField: true,
    expired: false
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(AuthenticatedContainer);



// WEBPACK FOOTER //
// ./src/Fuse/components/AuthenticatedContainer.js